import { render } from "./ServiceSupport.vue?vue&type=template&id=16d0cafe&scoped=true"
import script from "./ServiceSupport.vue?vue&type=script&lang=js"
export * from "./ServiceSupport.vue?vue&type=script&lang=js"

import "./ServiceSupport.vue?vue&type=style&index=0&id=16d0cafe&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d0cafe"]])

export default __exports__